<template>
  <v-container fluid class="fill-height pa-0 login-layout">
    <v-row no-gutters class="fill-height">
      
      <v-col cols="12" md="6" class="hero-container d-none d-md-flex">
        <div class="brand-display">
          <div class="brand-orbit-wrapper">
            <svg viewBox="0 0 100 100" class="brand-orbit-svg">
              <circle cx="50" cy="50" r="45" stroke="rgba(186, 107, 48, 0.1)" stroke-width="0.5" fill="none" />
              <circle cx="50" cy="5" r="1.5" fill="#BA6B30" class="orbit-particle-1" />
              <circle cx="95" cy="50" r="1" fill="#BA6B30" class="orbit-particle-2" />
              <circle cx="5" cy="50" r="1.2" fill="#BA6B30" class="orbit-particle-3" />
            </svg>
            <img 
              src="@/assets/bear-face-icon-2.png" 
              alt="Legor Bear" 
              class="brand-bear-img head-look-anim"
            />
          </div>
          
          <div class="brand-text-overlay mt-10">
            <h2 class="text-h2 font-weight-black white--text tracking-tighter">
              LEGOR<span class="orange--text text--darken-2">ERP</span>
            </h2>
            <div class="divider-gradient"></div>
            <p class="text-h6 grey--text text--lighten-1 font-weight-thin mt-4 tracking-widest">
              ENTERPRISE RESOURCE PLANNING
            </p>
          </div>
        </div>
      </v-col>

      <v-col cols="12" md="6" class="d-flex align-center justify-center pa-6">
        <div class="form-container-wrapper">
          
          <div class="welcome-header mb-8">
            <h1 class="text-h3 font-weight-black white--text mb-2">
              Bienvenido a <span class="company-highlight">{{ empresa_nombre || 'Legor Systems' }}</span>
            </h1>
            <p class="grey--text text-h6 font-weight-light">
              Inicia sesión para gestionar tu negocio.
            </p>
          </div>

          <v-card flat :class="['pa-10 login-card border-glass', { 'shake-anim': shake }]" width="100%">
            <div class="text-start mb-8">
  <h2 class="orange--text text--darken-2 font-weight-black text-h5 tracking-widest uppercase">
    INICIAR SESIÓN
  </h2>
</div>

            <v-card-text class="pa-0">
              <v-expand-transition>
                <v-alert v-if="error" dense outlined type="error" class="mb-6 rounded-lg text-caption">
                  {{ errorMessage }}
                </v-alert>
              </v-expand-transition>

              <v-form ref="loginForm" v-model="valid" lazy-validation @submit.prevent="submit">
                <v-text-field
                  dark outlined label="Usuario"
                  v-model="user.username"
                  :rules="[v => !!v || 'Campo requerido']"
                  prepend-inner-icon="mdi-account-outline"
                  class="custom-field mb-4"
                  hide-details="auto"
                  :disabled="loadingDataInit"
                />

                <v-text-field
                  ref="passwordField"
                  dark outlined label="Contraseña"
                  v-model="user.password"
                  :rules="[v => !!v || 'Campo requerido']"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                  @click:append="showPassword = !showPassword"
                  prepend-inner-icon="mdi-lock-outline"
                  class="custom-field"
                  hide-details="auto"
                  :disabled="loadingDataInit"
                />

                <v-btn
                  x-large block type="submit"
                  :loading="loadingDataInit"
                  class="mt-10 btn-login white--text"
                  elevation="12"
                >
                  {{ loadingDataInit ? 'Verificando...' : 'Entrar al Sistema' }}
                </v-btn>
              </v-form>
            </v-card-text>

            <div class="mt-10 d-flex align-center justify-space-between opacity-4">
              <span class="grey--text text-caption font-weight-light">Build 2026 • v{{ empresa_version }}</span>
              <span class="grey--text text-caption font-weight-light">&copy; LEGORSOFT</span>
            </div>
          </v-card>

        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.login-layout {
  background: radial-gradient(circle at 75% 25%, #1a110d 0%, #050505 100%);
  min-height: 100vh;
}

/* Hero Branding */
.hero-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  border-right: 1px solid rgba(255, 255, 255, 0.03);
}
.brand-display { text-align: center; }
.brand-orbit-wrapper {
  position: relative;
  width: 320px;
  height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.brand-orbit-svg { position: absolute; width: 100%; height: 100%; animation: rotate-slow 40s linear infinite; }
.brand-bear-img { width: 160px; z-index: 2; filter: drop-shadow(0 15px 40px rgba(0,0,0,0.7)); }
.divider-gradient { height: 2px; width: 60px; background: linear-gradient(90deg, transparent, #BA6B30, transparent); margin: 15px auto; }

/* Formulario Lado Derecho */
.form-container-wrapper { width: 100%; max-width: 480px; }
.welcome-header { text-align: left; }
.company-highlight { color: #BA6B30; font-weight: 200; }

.login-card {
  background: rgba(255, 255, 255, 0.02) !important;
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px);
  border-radius: 20px !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  box-shadow: 0 50px 100px rgba(0, 0, 0, 0.6) !important;
}

.line-accent { width: 25px; height: 3px; background: #BA6B30; border-radius: 2px; }

.custom-field ::v-deep .v-input__control > .v-input__slot {
  background: rgba(0, 0, 0, 0.4) !important;
  border-radius: 12px !important;
}

.btn-login {
  background: linear-gradient(135deg, #ba6b30 0%, #8e4d1e 100%) !important;
  border-radius: 12px !important;
  font-weight: 800 !important;
  height: 62px !important;
  text-transform: none;
  letter-spacing: 1px;
}

/* Animaciones */
.orbit-particle-1 { animation: orbit-1 10s linear infinite; transform-origin: 50% 50%; }
.orbit-particle-2 { animation: orbit-1 15s linear infinite reverse; transform-origin: 50% 50%; }
.orbit-particle-3 { animation: orbit-1 12s linear infinite; transform-origin: 50% 50%; }
@keyframes orbit-1 { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
@keyframes rotate-slow { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
.head-look-anim { animation: head-look 10s ease-in-out infinite; }
@keyframes head-look {
  0%, 100% { transform: rotate(0deg) scale(1); }
  25% { transform: rotate(3deg) translateY(-5px); }
  75% { transform: rotate(-3deg) translateY(0px); }
}
.shake-anim { animation: shake 0.6s cubic-bezier(.36,.07,.19,.97) both; }
@keyframes shake {
  10%, 90% { transform: translate3d(-1px, 0, 0); }
  20%, 80% { transform: translate3d(2px, 0, 0); }
  30%, 50%, 70% { transform: translate3d(-4px, 0, 0); }
  40%, 60% { transform: translate3d(4px, 0, 0); }
}
.opacity-4 { opacity: 0.4; }
</style>
<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "Login",
  data: () => ({
    valid: true,
    shake: false,
    showPassword: false,
    user: { username: "", password: "" },
  }),
  computed: {
    ...mapState(["error", "errorMessage"]),
    ...mapGetters("empresa", ["empresa_nombre", "empresa_version"]),
    ...mapState("initialData", ["loadingDataInit"]),
  },
  methods: {
    ...mapActions("auth", ["signIn"]),
    async submit() {
      if (this.$refs.loginForm.validate()) {
        try {
          await this.signIn(this.user);
        } catch (err) {
          this.triggerShake();
        }
      } else {
        this.triggerShake();
      }
    },
    triggerShake() {
      this.shake = true;
      setTimeout(() => (this.shake = false), 600);
    },
  },
  created() {
    this.$store.commit("SET_LAYOUT", { layout: "layout-login" });
  },
};
</script>